import * as React from 'react';
import { KeywordTextInput } from './keyword-text-input';
export var ActivityKeywordSearchInput = function (_a) {
  var isCarousel = _a.isCarousel,
    inDialog = _a.inDialog;
  return React.createElement(KeywordTextInput, {
    isCarousel: isCarousel,
    inDialog: inDialog
  });
};